import React from 'react'
import styled from 'styled-components'
import { useTheme } from '@mui/material/styles'
import RadioField from '@/v2/components/common/RadioField'
import PatientForm from '@/v2/components/forms/Patient/Form'
import SelectedPatient from '@/v2/components/common/SelectedPatient'
import PatientSearch from '@/v2/components/common/PatientSearch'
import Typography from '@/v2/components/common/Typography'
import WarningIcon from '@mui/icons-material/WarningAmberRounded'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`

const PatientInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const WarningBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: ${({ theme }) => theme.red.medicalAlert};
  color: ${({ theme }) => theme.background.default};
  border-radius: 4px;
  border-left: 4px solid ${({ theme }) => theme.red.main};
  max-width: 440px;
  width: 100%;
  margin: 0 auto;
`

const PatientSelection = ({
  patientType,
  registeredPatient,
  newPatient,
  error,
  canRemove = false,
  onChange,
}) => {
  const theme = useTheme()

  return (
    <Wrapper>
      {canRemove && (
        <RadioField
          color="secondary"
          value={patientType}
          options={[
            { label: 'Returning Patient', value: 'registered' },
            { label: 'New Patient', value: 'new' },
          ]}
          onChange={value => onChange({ patientType: value })}
        />
      )}
      {patientType === 'new' && (
        <PatientForm
          values={newPatient}
          error={error.newPatient}
          onChange={value => onChange({ newPatient: { ...value } })}
        />
      )}
      {patientType === 'registered' && !registeredPatient.id && (
        <PatientSearch
          autoFocus
          showSearchIcon
          error={error.registeredPatient}
          onChange={patient =>
            onChange({
              registeredPatient: patient,
              contactMethod: patient.contactMethod,
            })
          }
        />
      )}
      {registeredPatient.id && (
        <PatientInfoWrapper>
          <SelectedPatient
            registeredPatient={registeredPatient}
            canRemove={canRemove}
            onChange={() => onChange({ registeredPatient: {} })}
          />
          {registeredPatient.hasOverdueInvoice && (
            <WarningBox theme={theme.palette}>
              <WarningIcon sx={{ fontSize: '18px', flexShrink: 0 }} />
              <Typography fontSize="13px">
                This patient has an overdue invoice or a declined payment (from
                automatic charge) that requires attention.
              </Typography>
            </WarningBox>
          )}
        </PatientInfoWrapper>
      )}
    </Wrapper>
  )
}

export default PatientSelection
